module.exports = __webpack_public_path__ + "img/symbol_0.d169c8ce.png";